module.exports = __webpack_public_path__ + "static/media/map-uk-v3.3d2d98c3.png";